"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePolicyConfirmationDto = exports.PolicyConfirmationDocumentDto = exports.PolicyDataRectifiedSectionDto = exports.DeviationSectionDto = exports.PolicyDataWrongSectionDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class PolicyDataWrongSectionDto {
}
exports.PolicyDataWrongSectionDto = PolicyDataWrongSectionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 0,
        description: "Flag indicating if policy data is wrong (1=Yes, 0=No)",
        required: false,
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], PolicyDataWrongSectionDto.prototype, "policyDataWrongLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Flag indicating if deviation was revised (1=Yes, 0=No)",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], PolicyDataWrongSectionDto.prototype, "deviationResolvedLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Need to verify with underwriting team",
        description: "Additional comments",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PolicyDataWrongSectionDto.prototype, "comments", void 0);
class DeviationSectionDto {
}
exports.DeviationSectionDto = DeviationSectionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Policy amount discrepancy found",
        description: "Description of deviations",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], DeviationSectionDto.prototype, "deviations", void 0);
class PolicyDataRectifiedSectionDto {
}
exports.PolicyDataRectifiedSectionDto = PolicyDataRectifiedSectionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Flag indicating if policy data is reflected correctly (1=Yes, 0=No)",
        required: false,
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], PolicyDataRectifiedSectionDto.prototype, "policyDataRectifiedLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 3,
        description: "Resolution type ID",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], PolicyDataRectifiedSectionDto.prototype, "resolutionLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "High priority case",
        description: "General remarks",
        required: false,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PolicyDataRectifiedSectionDto.prototype, "remarks", void 0);
class PolicyConfirmationDocumentDto {
}
exports.PolicyConfirmationDocumentDto = PolicyConfirmationDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], PolicyConfirmationDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], PolicyConfirmationDocumentDto.prototype, "documentId", void 0);
class CreatePolicyConfirmationDto {
}
exports.CreatePolicyConfirmationDto = CreatePolicyConfirmationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: false,
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreatePolicyConfirmationDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Status ID",
        required: false,
    }),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CreatePolicyConfirmationDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PolicyDataWrongSectionDto),
    tslib_1.__metadata("design:type", PolicyDataWrongSectionDto)
], CreatePolicyConfirmationDto.prototype, "policyDataWrongSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DeviationSectionDto),
    tslib_1.__metadata("design:type", DeviationSectionDto)
], CreatePolicyConfirmationDto.prototype, "deviationSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PolicyDataRectifiedSectionDto),
    tslib_1.__metadata("design:type", PolicyDataRectifiedSectionDto)
], CreatePolicyConfirmationDto.prototype, "policyDataRectifiedSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [PolicyConfirmationDocumentDto],
        description: "Array of documents",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PolicyConfirmationDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreatePolicyConfirmationDto.prototype, "documents", void 0);
